<template>
  <div v-if="!carregando">
    <div class="cabecalho">
      <div>
        <h2>{{ paciente.nome_social }}</h2>
        <h4 v-if="paciente.nome_social !== paciente.nome">{{
          paciente.nome
        }}</h4>
        <h4>
          <strong>Idade:</strong> {{ dataNascimento }} anos.
          <strong>Sexo:</strong> {{ paciente.sexo || 'Não informado' }}.
          <strong>Profissão:</strong>
          {{ paciente.profissao || 'Não informada' }}.
        </h4>
      </div>
      <div class="hidden-print">
        <button
          id="botaoAdicionar"
          data-test-id="button-botaoadicionar"
          type="button"
          class="btn btn-primary"
          @click="adicionarNovo"
        >
          <span class="fa fa-plus"></span> Adicionar
        </button>
      </div>
    </div>
    <div v-if="evolucao.evolucoes && evolucao.evolucoes.length">
      <div
        class="hidden-print"
        style="display: flex; justify-content: space-between"
      >
        <Tabs v-model="abaSelecionada" pills @change="aoAlterarAba">
          <Tab title="Todos"></Tab>
          <Tab
            v-for="form in formulariosEmEvolucaoDoPaciente"
            :key="form._id"
            :title="`${form.nome} (${form.total})`"
          ></Tab>
        </Tabs>
        <div>
          <button
            data-test-id="button-toggletodos-2"
            type="button"
            class="btn btn-default"
            @click="toggleTodos(false)"
          >
            Minimizar todos
          </button>
          <button
            data-test-id="button-toggletodos-3"
            type="button"
            class="btn btn-default"
            @click="toggleTodos(true)"
          >
            Expandir todos
          </button>
        </div>
      </div>
      <div
        v-for="(item, index) of evolucao.evolucoes"
        :key="item._id || index"
        class="evolucao-item"
      >
        <div class="evolucao-cabecalho-wrapper">
          <div class="evolucao-cabecalho">
            <div>
              <div style="display: flex; gap: 8px">
                <div class="hidden-print" style="margin: auto 0">
                  <button
                    data-test-id="button-toggleevolucao-4"
                    type="button"
                    class="btn btn-default btn-sm"
                    style="padding: 0; margin-top: 8px"
                    @click="toggleEvolucao(index)"
                  >
                    <span
                      :class="
                        evolucaoToggle[index]
                          ? 'fa fa-chevron-down'
                          : 'fa fa-chevron-right'
                      "
                    ></span>
                  </button>
                </div>
                <h3 class="text-primary">
                  {{ formatarData(item.data, 'DD/MM/YY HH:mm', true) }}
                  &bull;
                  {{ item.formulario.nome }}
                  &bull;
                  {{ item.autor.nome }}
                </h3>
              </div>
              <h4
                class="text-danger"
                style="margin-top: -6px; margin-left: 24px"
              >
                {{
                  formatarPatologiasPregressas(item.guia.patologiasPregressas)
                }}
              </h4>
            </div>
            <div v-if="evolucaoToggle[index]" class="informacao-grupo">
              <div>
                <div class="informacao">
                  <div class="informacao-titulo"> Guia </div>
                  <div class="informacao-valor">
                    {{ item.guia.numero }}
                  </div>
                  <div class="informacao-valor">
                    {{ item.guia.especialidade.nome }}
                  </div>
                  <div class="informacao-valor">
                    {{ item.guia.cid }}
                  </div>
                </div>
              </div>
              <div>
                <div class="informacao">
                  <div class="informacao-titulo"> Sessão </div>
                  <div class="informacao-valor">
                    {{ formatarData(item.agendamento.data, 'DD/MM/YYYY') }} :
                    {{ item.agendamento.hora }}
                  </div>
                  <div class="informacao-valor">
                    {{ item.agendamento.index }} /
                    {{ item.agendamento.total }}
                  </div>
                  <div class="informacao-valor">
                    {{ item.agendamento.especialidade }}
                    {{ item.agendamento.unidade }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="hidden-print">
            <button
              data-test-id="button-abrirevolucaoitem-5"
              type="button"
              class="btn btn-default"
              @click="abrirEvolucaoItem(item)"
            >
              <span class="fa fa-edit"></span> Editar
            </button>
          </div>
        </div>
        <div
          v-if="evolucaoToggle[index] && item.formulario.grupoRespostas"
          style="margin-left: 24px"
        >
          <div
            v-for="(grupo, j) of item.formulario.grupoRespostas.filter((g) =>
              g.respostas.some((r) => r.valor)
            )"
            :key="grupo._id || j"
          >
            <div
              v-if="grupo.titulo && grupo.respostas"
              class="resposta-questao-item-titulo"
            >
              <button
                data-test-id="button-togglegrupoevolucao-6"
                type="button"
                class="hidden-print btn btn-default btn-xs"
                style="padding: 0; margin: 0"
                @click="toggleGrupoEvolucao(index, j)"
              >
                <span
                  :class="[
                    'fa',
                    evolucaoGruposToggle[index] &&
                    evolucaoGruposToggle[index][j]
                      ? 'fa-chevron-down'
                      : 'fa-chevron-right',
                  ]"
                >
                </span>
              </button>
              {{ grupo.titulo }}
            </div>
            <div
              v-if="
                !evolucaoGruposToggle[index] ||
                (evolucaoGruposToggle[index] && evolucaoGruposToggle[index][j])
              "
              class="resposta-questao-item"
            >
              <div
                v-for="(resposta, k) of grupo.respostas.filter(
                  (resp) => !!resp.valor
                )"
                :key="k"
                :class="{
                  'resposta-questao-item-linha': resposta.questao.expandida,
                }"
              >
                <p class="resposta-enunciado">
                  {{ resposta.questao.enunciado }}
                </p>
                <ul
                  v-if="resposta.questao.tipo === 'Domínio'"
                  class="resposta-valor-container"
                >
                  <li
                    v-for="v of resposta.valor.split(',')"
                    :key="v"
                    class="resposta-valor"
                  >
                    {{ v }}
                    <p
                      v-if="resposta.complemento && resposta.complemento[v]"
                      class="resposta-valor-complemento"
                    >
                      {{ resposta.complemento[v] }}
                    </p>
                  </li>
                </ul>
                <p
                  v-else-if="resposta.questao.tipo === 'Data'"
                  class="resposta-valor"
                >
                  {{ resposta.valor }}
                </p>
                <p
                  v-else-if="resposta.questao.tipo === 'Fracionário'"
                  class="resposta-valor"
                >
                  {{ resposta.valor }}
                </p>
                <p
                  v-else-if="resposta.questao.tipo === 'Inteiro'"
                  class="resposta-valor"
                >
                  {{ resposta.valor }}
                </p>
                <p
                  v-else-if="resposta.questao.tipo === 'Sim/Não'"
                  class="resposta-valor"
                >
                  <span v-if="resposta.valor === null">-</span>
                  <span v-else>
                    {{ resposta.valor === true ? 'Sim' : 'Não' }}
                  </span>
                </p>
                <p
                  v-else-if="resposta.questao.tipo === 'Texto'"
                  class="resposta-valor"
                  v-html="resposta.valor"
                >
                </p>
                <p
                  v-else-if="resposta.questao.tipo === 'EVA'"
                  class="resposta-valor"
                >
                  {{ resposta.valor }}
                </p>
                <CampoTabelaValores
                  v-else-if="resposta.questao.tipo === 'Tabela'"
                  :valor="resposta.valor"
                  readonly
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="well"> Nenhum dado encontrado </div>

    <dialog
      v-if="!!evolucaoItem"
      id="evolucaoDialog"
      class="evolucao-dialog"
      :style="showDialog ? 'display: flex' : ''"
    >
      <h2 class="text-primary">Evolução</h2>
      <div class="row">
        <div class="col-xs-6 col-sm-4 col-md-4 col-lg-4">
          <SelecionarData
            :valor="evolucaoItem.data"
            :somente-leitura="!!evolucaoItem._id"
            @atualizar="evolucaoItem.data = $event"
          />
        </div>
        <div class="col-xs-6 col-sm-4 col-md-4 col-lg-4">
          <SelecionarGenerico
            id="especialidade"
            label="Especialidade"
            opcao-sem-valor="Selecione"
            :somente-leitura="!!evolucaoItem._id"
            :valores="especialidades"
            :valor="
              evolucaoItem.especialidade
                ? evolucaoItem.especialidade
                : evolucaoItem.agendamento
                  ? evolucaoItem.agendamento.especialidade
                  : undefined
            "
            @atualizar="aoAtualizarEspecialidade"
          />
        </div>
        <div class="col-xs-6 col-sm-4 col-md-4 col-lg-4">
          <SelecionarGenerico
            id="formulario"
            label="Formulário"
            opcao-sem-valor="Selecione"
            descricao="nome"
            :somente-leitura="!!evolucaoItem._id"
            :valores="formularios"
            :valor="evolucaoItem.formulario._id"
            @atualizar="atualizarFormulario($event)"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-6 col-sm-4 col-md-4 col-lg-4">
          <div v-if="agendamentos.length" class="form-group">
            <label>Sessão</label>
            <select
              data-test-id="select-auto-7"
              class="form-control"
              :disabled="!!evolucaoItem._id"
              :value="agendamento._id"
              @change="aoAtualizarAgendamento"
            >
              <option
                v-for="a in agendamentos"
                :key="a._id"
                :value="a._id"
                :selected="a._id === agendamento._id"
              >
                {{ formatarData(a.data, 'DD/MM/YYYY') }} {{ a.hora }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-4 col-lg-4">
          <div v-if="agendamento && agendamento.guia" class="form-group">
            <label>Guia</label>
            <select
              data-test-id="select-auto-8"
              class="form-control"
              :disabled="!!evolucaoItem._id"
              :value="guia._id"
              @change="aoAtualizarGuia"
            >
              <option
                v-for="g in agendamento.guia"
                :key="g._id"
                :value="g._id"
                :selected="g._id === guia._id"
              >
                {{ g.numero }} - {{ g.especialidade }} - {{ g.cid }}
              </option>
            </select>
            <div v-if="pendenciaMateriais" class="alerta">
              <span class="fa fa-exclamation-circle" />
              <span> Guia com pendência de materiais </span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <SelecionarMultiploDominio
          id="patologiasPregressas"
          dominio="Patologias Pregressas"
          label="Patologias pregressas"
          :mostrar-todos="false"
          :mostrar-outros="true"
          @atualizar="aoAtualizarPatologiasPregressas($event)"
        />
      </div>

      <div
        v-if="evolucaoItem.formulario && evolucaoItem.formulario.grupoRespostas"
      >
        <div
          v-for="(grupo, index) of evolucaoItem.formulario.grupoRespostas"
          :key="index"
        >
          <div class="resposta-titulo">
            {{ grupo.titulo }}
          </div>
          <div class="resposta">
            <div
              v-for="(resposta, j) of grupo.respostas"
              :key="j"
              class="resposta-inner"
              :class="{
                'resposta-questao-item-linha': resposta.questao.expandida,
              }"
            >
              <div class="resposta-enunciado-wrapper">
                <label class="resposta-enunciado-dialog">
                  {{ resposta.questao.enunciado }}
                </label>
                <div class="btn-group btn-group-sm" role="group">
                  <button
                    v-for="(respPadrao, k) of resposta.questao.respostasPadroes"
                    :key="k"
                    type="button"
                    class="btn btn-default btn-sm"
                    @click="
                      aoAtualizarComRespostaPadrao(
                        index,
                        j,
                        respPadrao.texto,
                        respPadrao.titulo
                      )
                    "
                  >
                    {{ limitar(respPadrao.titulo, 40) }}
                  </button>
                </div>
              </div>
              <SelecionarMultiploDominio
                v-if="resposta.questao.tipo === 'Domínio'"
                :id="resposta.questao._id"
                :dominio="resposta.questao.dominio"
                :mostrar-todos="false"
                :mostrar-outros="true"
                :exibe-label="false"
                :valor="resposta.valor"
                :complemento="resposta.complemento || {}"
                @complementar="aoComplementarResposta(index, j, $event)"
                @atualizar="aoAtualizarResposta(index, j, $event)"
              />
              <SelecionarData
                v-else-if="resposta.questao.tipo === 'Data'"
                :id="resposta.questao._id"
                :exibe-label="false"
                :valor="resposta.valor"
                @atualizar="aoAtualizarResposta(index, j, $event)"
              />
              <CampoGenerico
                v-else-if="resposta.questao.tipo === 'Fracionário'"
                :id="resposta.questao._id"
                :exibe-label="false"
                mascara="money"
                :valor="resposta.valor"
                @blur="aoAtualizarResposta(index, j, $event)"
              />
              <CampoGenerico
                v-else-if="resposta.questao.tipo === 'Inteiro'"
                :id="resposta.questao._id"
                mascara="999999"
                :valor="resposta.valor"
                :exibe-label="false"
                @blur="aoAtualizarResposta(index, j, $event)"
              />
              <select
                v-else-if="resposta.questao.tipo === 'Sim/Não'"
                :id="resposta.questao._id"
                v-model="resposta.valor"
                :data-test-id="`select-${resposta.questao._id}`"
                class="form-control"
              >
                <option :value="true">Sim</option>
                <option :value="false">Não</option>
              </select>
              <Editor
                v-else-if="resposta.questao.tipo === 'Texto'"
                v-model="resposta.valor"
              />
              <CampoEva
                v-else-if="resposta.questao.tipo === 'EVA'"
                :valor="resposta.valor"
                @atualizar="aoAtualizarResposta(index, j, $event)"
              />
              <CampoTabelaValores
                v-else-if="resposta.questao.tipo === 'Tabela'"
                :valor="resposta.valor"
                @atualizar="aoAtualizarResposta(index, j, $event)"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="evolucao-dialog-botoes">
        <span class="text-danger">
          {{ erro }}
        </span>
        <button
          data-test-id="button-limparevolucaoitem-10"
          class="btn btn-link"
          @click="limparEvolucaoItem"
        >
          Cancelar
        </button>
        <div style="display: flex; gap: 12px">
          <button
            data-test-id="button-salvarevolucaoitem-11"
            class="btn btn-primary"
            @click="salvarEvolucaoItem"
          >
            Salvar
          </button>
        </div>
      </div>
    </dialog>
  </div>
</template>

<script>
import moment from 'moment'

import CampoEva from '@/componentes/formulario/CampoEva'
import CampoGenerico from '@/componentes/formulario/CampoGenerico'
import CampoTabelaValores from '@/componentes/formulario/CampoTabelaValores'
import Editor from '@/componentes/formulario/Editor'
import SelecionarData from '@/componentes/formulario/SelecionarData'
import SelecionarGenerico from '@/componentes/formulario/SelecionarGenerico'
import SelecionarMultiploDominio from '@/componentes/formulario/SelecionarMultiploDominio'
import { useMenu } from '@/composables/useMenu'
import { dominioMixin } from '@/mixins/DominioMixin'
import AgendamentoServico from '@/servicos/AgendamentoServico'
import EvolucaoServico from '@/servicos/EvolucaoServico'
import FormularioServico from '@/servicos/FormularioServico'
import GuiaServico from '@/servicos/GuiaServico'
import PacienteServico from '@/servicos/PacienteServico'
import * as formatadores from '@/utils/formatadores'

const agendamentoServico = new AgendamentoServico()
const guiaServico = new GuiaServico()
const pacienteServico = new PacienteServico()
const evolucaoServico = new EvolucaoServico()
const formularioServico = new FormularioServico()

export default {
  components: {
    Editor,
    CampoEva,
    CampoTabelaValores,
    CampoGenerico,
    SelecionarMultiploDominio,
    SelecionarData,
    SelecionarGenerico,
  },
  mixins: [dominioMixin],
  setup() {
    useMenu(67)
  },
  data() {
    return {
      erro: null,
      carregando: false,
      abaSelecionada: 0,
      showDialog: false,
      paciente: null,
      evolucao: null,
      formularios: [],
      agendamento: null,
      agendamentoAvaliacaoNasGuias: [],
      guia: {},
      agendamentos: [],
      especialidades: [],
      evolucaoItem: {
        data: new Date().toISOString(),
        especialidade: '',
        formulario: { _id: null, nome: '', respostas: [] },
      },
      patologiasPregressasDominio: null,
      patologiasPregressas: null,
      formulariosEmEvolucaoDoPaciente: null,
      evolucaoToggle: [],
      evolucaoGruposToggle: [],
      pendenciaMateriais: false,
    }
  },
  computed: {
    dataNascimento() {
      return moment().diff(this.paciente.data_nascimento, 'years')
    },
  },
  async created() {
    this.inicializar()
  },
  methods: {
    ...formatadores,
    aoAtualizarEspecialidade(especialidade) {
      this.evolucaoItem.especialidade = especialidade
      this.carregarFormularios()
      this.carregarAgendamentosNaEspecialidade()
    },
    toggleTodos(toggle) {
      this.evolucaoToggle = this.evolucao.evolucoes.map(() => toggle)
      this.evolucaoGruposToggle = this.evolucao.evolucoes.map((e) => {
        return e.formulario.grupoRespostas.map(() => toggle)
      })
    },
    toggleEvolucao(index) {
      this.$set(this.evolucaoToggle, index, !this.evolucaoToggle[index])
    },
    toggleGrupoEvolucao(i, j) {
      const gruposToggle = [...this.evolucaoGruposToggle[i]]
      gruposToggle[j] = !gruposToggle[j]
      this.$set(this.evolucaoGruposToggle, i, gruposToggle)
    },
    async aoAlterarAba() {
      if (this.abaSelecionada === 0) {
        await this.carregarEvolucao()
        return
      }

      const form = this.formulariosEmEvolucaoDoPaciente[this.abaSelecionada - 1]
      if (form) await this.carregarEvolucao({ formularioID: form._id })
    },
    formatarPatologiasPregressas(patologiasPregressas) {
      if (!patologiasPregressas || !patologiasPregressas.length) {
        return ''
      }

      return patologiasPregressas
        .filter((pp) => pp.possui)
        .map((pp) => (pp.nome === 'Outro' ? pp.valor : pp.nome))
        .join(', ')
    },
    async inicializar() {
      this.carregando = true

      await Promise.all([
        this.carregarFormulariosEmEvolucao(),
        this.carregarPatologiaPregressasDominio(),
        this.carregarAgendamento(this.$route.query.agendamento),
        this.carregarPaciente(),
        this.carregarEvolucao(),
      ])

      await this.carregarEspecialidades()
      this.carregando = false
    },
    ultimaAtualizacao(evolucaoItem) {
      return moment(evolucaoItem.criadoEm).from(evolucaoItem.atualizadoEm)
    },
    aoAtualizarAgendamento(event) {
      this.carregarAgendamento(event.target.value)
      this.carregarFormularios(event.target.value)
    },
    async aoAtualizarGuia(event) {
      this.guia = this.agendamento.guia.find(
        (g) => g._id === event.target.value
      )
      const response = await pacienteServico.recuperarPatologiasPregressas(
        this.paciente._id,
        { guiaID: this.guia._id }
      )

      if (response.patologiasPregressas) {
        const resPatologiasPregressas = response.patologiasPregressas.find(
          (pp) => pp.guia._id === this.guia._id
        )
        if (resPatologiasPregressas) {
          this.patologiasPregressas =
            resPatologiasPregressas.patologiasPregressas
          this.guia.patologiasPregressas = this.patologiasPregressas
        }
      }

      this.evolucaoItem.especialidade = this.guia.especialidade
      this.validarPendenciaDeMateriais()
    },
    async carregarFormulariosEmEvolucao() {
      const pacienteId = this.$route.params.id
      const { formularios } =
        await evolucaoServico.recuperarFormulariosEmEvolucaoPaciente(pacienteId)
      this.formulariosEmEvolucaoDoPaciente = formularios
    },
    async carregarPatologiaPregressasDominio() {
      const { valores } = await this.recuperarValoresDominio(
        'Patologias Pregressas'
      )
      this.patologiasPregressasDominio = valores
    },
    async carregarAgendamentosNaEspecialidade() {
      const pacienteId = this.$route.params.id

      if (!this.evolucaoItem.especialidade) {
        return
      }

      const { agendamentos } =
        await evolucaoServico.recuperaAgendamentosNaEspecialidade(
          pacienteId,
          this.evolucaoItem.especialidade
        )

      this.agendamentos = agendamentos

      // adiciona tb o agendamento passado na rota para
      if (this.agendamento && this.agendamento != null) {
        this.agendamentos.push(this.agendamento)
      }
    },
    async carregarAgendamento(agendamentoId) {
      const pacienteId = this.$route.params.id
      if (!agendamentoId) return

      const { agendamento } =
        await agendamentoServico.recuperarAgendamentoWithCID(agendamentoId)

      this.agendamento = agendamento

      if (this.agendamento.guia && this.agendamento.guia.length === 1) {
        this.guia = this.agendamento.guia[0]
        const response = await pacienteServico.recuperarPatologiasPregressas(
          pacienteId,
          {
            guiaID: this.guia._id,
          }
        )

        if (response.patologiasPregressas) {
          const resPatologiasPregressas = response.patologiasPregressas.find(
            (pp) => pp.guia._id === this.guia._id
          )
          if (resPatologiasPregressas) {
            this.patologiasPregressas =
              resPatologiasPregressas.patologiasPregressas
            this.guia.patologiasPregressas = this.patologiasPregressas
          }
        }
      }

      const { guias } =
        await guiaServico.verificaSePrimeiroAgendamentoDaGuia(agendamentoId)

      this.agendamentoAvaliacaoNasGuias = guias
    },
    async carregarEspecialidades() {
      if (
        this.agendamentoAvaliacaoNasGuias &&
        this.agendamentoAvaliacaoNasGuias.length
      ) {
        this.especialidades = this.agendamentoAvaliacaoNasGuias.map((g) => ({
          _id: g.especialidade,
          descricao: g.especialidade,
        }))
      } else {
        const { especialidades } =
          await evolucaoServico.recuperarEspecialidadesComAgendamentos(
            this.$route.params.id
          )

        this.especialidades = especialidades.map((e) => ({
          _id: e,
          descricao: e,
        }))
      }
    },
    async carregarPaciente() {
      const pacienteId = this.$route.params.id
      const { paciente } = await pacienteServico.recuperar(pacienteId)
      this.paciente = paciente
    },
    async carregarEvolucao(params) {
      const pacienteId = this.$route.params.id
      this.evolucao = await pacienteServico.recuperarEvolucao(
        pacienteId,
        params
      )

      this.evolucaoToggle = this.evolucao.evolucoes.map(() => true)
      this.evolucaoGruposToggle = this.evolucao.evolucoes.map((e) => {
        return e.formulario.grupoRespostas.map(() => true)
      })
    },
    abrirEvolucaoDialog() {
      setTimeout(() => {
        const dialog = document.querySelector('#evolucaoDialog')
        if (dialog) dialog.showModal()
      }, 100)
    },
    async adicionarNovo() {
      this.limparEvolucaoItem()

      if (this.agendamento) {
        this.evolucaoItem.agendamento = this.agendamento
        this.evolucaoItem.especialidade = this.agendamento.especialidade
      }

      if (this.guia) {
        this.evolucaoItem.guia = this.guia
        this.evolucaoItem.especialidade = this.guia.especialidade
      }

      await this.carregarFormularios()
      await this.carregarAgendamentosNaEspecialidade()
      this.abrirEvolucaoDialog()
      this.validarPendenciaDeMateriais()
    },
    limparEvolucaoItem() {
      this.evolucaoItem = {
        data: new Date().toISOString(),
        especialidade: '',
        formulario: { _id: null, nome: '', respostas: [] },
      }
      this.showDialog = false
      const dialog = document.querySelector('#evolucaoDialog')
      if (dialog) dialog.close()
    },
    async salvarEvolucaoItem() {
      await pacienteServico.atualizarPatologiasPregressas(this.paciente._id, {
        guia: { _id: this.guia._id },
        patologiasPregressas: this.patologiasPregressas,
      })

      let resultado

      if (this.evolucaoItem._id) {
        resultado = await pacienteServico.atualizarEvolucao(
          this.paciente._id,
          this.evolucaoItem._id,
          {
            ...this.evolucaoItem,
          }
        )
      } else {
        resultado = await pacienteServico.adicionarEvolucao(this.paciente._id, {
          ...this.evolucaoItem,
          agendamentoID: this.agendamento._id,
          guiaID: this.guia._id,
        })
      }

      if (resultado.erro) {
        this.erro = `${resultado.erro.title} - ${resultado.erro.content}`
        return
      }

      this.erro = null

      this.limparEvolucaoItem()
      await this.inicializar()
      await this.carregarFormularios()

      this.$router.replace({ name: 'Agendamento' })
    },
    abrirEvolucaoItem(item) {
      this.evolucaoItem = item
      this.patologiasPregressas = item.guia.patologiasPregressas
      this.showDialog = true
      this.abrirEvolucaoDialog()
    },
    excluirEvolucaoItem(item) {
      if (confirm('Tem certeza?') === true) {
        const pacienteId = this.$route.params.id
        pacienteServico.removerEvolucao(pacienteId, item._id)
      }
    },
    async carregarFormularios(agendamentoID) {
      if (!this.evolucaoItem.especialidade) return []

      let filtro = {
        especialidade: this.evolucaoItem.especialidade,
        avaliacao: false,
        ativo: true,
      }

      if (agendamentoID) {
        filtro.agendamento_id = agendamentoID
      } else if (this.agendamento) {
        filtro.agendamento_id = this.agendamento._id
      }

      const { formularios } = await formularioServico.recuperarTodos(filtro)

      this.formularios = formularios

      if (this.formularios && this.formularios.length === 1) {
        this.atualizarFormulario(this.formularios[0]._id)
      }

      if (this.evolucaoItem.formulario && this.evolucaoItem.formulario._id) {
        this.atualizarFormulario(this.evolucaoItem.formulario._id)
      }
    },
    atualizarFormulario(formularioId) {
      if (this.evolucaoItem._id) return

      if (!this.evolucaoItem.formulario) {
        this.evolucaoItem.formulario = {
          _id: null,
          nome: '',
          grupoRespostas: [],
        }
      }

      const formularioSelecionado = this.formularios.find(
        (f) => f._id === formularioId
      )

      if (!formularioSelecionado) {
        this.evolucaoItem.formulario._id = null
        this.evolucaoItem.formulario.nome = ''
        this.evolucaoItem.formulario.grupoRespostas = []
        return
      }

      this.evolucaoItem.formulario._id = formularioId
      this.evolucaoItem.formulario.nome = formularioSelecionado.nome
      this.evolucaoItem.formulario.grupoRespostas =
        formularioSelecionado.gruposQuestoes.map((grupo) => ({
          titulo: grupo.titulo,
          respostas: grupo.questoes.map((q) => {
            let valor = null

            if (['Texto', 'Domínio'].includes(q.tipo)) {
              valor = ''
            }

            return { questao: { ...q }, valor }
          }),
        }))
    },
    aoAtualizarResposta(i, j, valor) {
      const resposta =
        this.evolucaoItem.formulario.grupoRespostas[i].respostas[j]

      if (valor && ['Inteiro', 'Fracionário'].includes(resposta.questao.tipo)) {
        valor = valor.value

        this.$set(this.evolucaoItem.formulario.grupoRespostas[i].respostas, j, {
          ...resposta,
          valor,
        })

        this.$forceUpdate()
        return
      }

      this.$set(this.evolucaoItem.formulario.grupoRespostas[i].respostas, j, {
        ...resposta,
        valor,
      })

      this.$forceUpdate()
    },
    aoComplementarResposta(i, j, valor) {
      const resposta =
        this.evolucaoItem.formulario.grupoRespostas[i].respostas[j]

      this.$set(this.evolucaoItem.formulario.grupoRespostas[i].respostas, j, {
        ...resposta,
        complemento: { ...valor },
      })

      this.$forceUpdate()
    },
    aoAtualizarComRespostaPadrao(i, j, valor, titulo) {
      const novoValor = `${this.evolucaoItem.formulario.grupoRespostas[i].respostas[j].valor}<h3>${titulo}</h3><p>${valor}</p>`
      this.aoAtualizarResposta(i, j, novoValor)
    },
    aoAtualizarPatologiasPregressas(novoValor) {
      this.patologiasPregressas = this.patologiasPregressasDominio.map(
        (valor) => ({
          nome: valor.valor,
          possui: novoValor.includes(valor.valor),
        })
      )

      const difference = novoValor
        .split(',')
        .filter(
          (x) =>
            !this.patologiasPregressasDominio
              .map((ppd) => ppd.valor)
              .includes(x)
        )

      if (difference && difference.length === 1) {
        this.patologiasPregressas.push({
          nome: 'Outro',
          possui: true,
          valor: difference[0],
        })
      }
    },
    validarPendenciaDeMateriais() {
      if (
        !this.guia ||
        !this.guia._id ||
        this.guia.especialidade != 'Ortopedia'
      )
        return
      this.pendenciaMateriais = false
      guiaServico
        .validarPendenciaDeMateriaisPorId(this.guia._id)
        .then((pendencia) => {
          this.pendenciaMateriais = pendencia
        })
        .catch((erro) => {
          this.pendenciaMateriais = false
        })
    },
  },
}
</script>

<style scoped>
.cabecalho {
  position: sticky;
  top: 50px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  background: white;
  border-bottom: 1px solid #d4d4d4;
}

.evolucao-item {
  padding: 2px 8px;
  margin-bottom: 24px;
}

.evolucao-cabecalho-wrapper {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding-bottom: 5px;
  gap: 4px;
  margin-bottom: 12px;
}

.evolucao-cabecalho {
  display: flex;
  flex-flow: column;
}

.resposta-enunciado {
  margin: 0;
  font-size: 11pt;
  font-weight: bold;
}

.resposta-valor::marker {
  color: #008080;
}

.resposta-valor {
  font-size: 11pt;
  font-weight: lighter;
  color: black;
  list-style-type: square;
}

.resposta-valor-complemento {
  font-size: 9pt;
  font-style: italic;
}

.evolucao-dialog {
  display: hidden;
  flex-flow: column;
  width: calc(100vw - 180px);
  min-width: 468px;
  padding: 20px;
  background-color: #f9f9f9;
  border: 1px solid #ecf0f1;
  border-radius: 8px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  gap: 12px;
}

.evolucao-dialog-botoes {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
}

.resposta {
  display: flex;
  flex-flow: row wrap;
  gap: 12px;
}

.resposta-titulo {
  padding: 12px 0;
  margin-top: 18px;
  margin-bottom: 12px;
  font-size: 16px;
  border-bottom: 1px solid #ecf0f1;
}

.resposta-enunciado-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.resposta-inner {
  flex: 1 0 auto;
}

.resposta-enunciado-dialog {
  font-size: 10pt;
  font-weight: normal;
  line-height: 12pt;
}

.resposta-parte {
  display: flex;
  flex-flow: wrap;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}

.resposta-questao-item-titulo {
  display: flex;
  align-items: center;
  padding: 0 8px;
  margin-top: 4px;
  margin-bottom: -8px;
  font-size: 16px;
  font-weight: bolder;
  gap: 8px;
}

.resposta-questao-item {
  display: flex;
  flex-flow: row wrap;
  gap: 12px;
  padding: 4px 8px;
  margin: 12px 0 0 24px;
}

.resposta-questao-item-linha {
  flex-basis: 100%;
}

.informacao-grupo {
  display: flex;
  flex-flow: row nowrap;
  margin-left: 24px;
}

.informacao {
  padding: 6px 10px;
  margin: 6px 22px 6px 0;
  background-color: #ecf0f1;
  border-left: 8px solid #008080;
  transition: box-shadow 0.3s;
}

.informacao:hover {
  box-shadow: 0 0 4px rgba(33, 33, 33, 0.2);
}

.informacao-titulo {
  font-size: 0.9em;
  font-weight: bolder;
  text-align: right;
  text-transform: uppercase;
}

.informacao-valor {
  font-size: 1.3em;
}
.alerta {
  position: absolute;
  left: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  color: #d35400;
}
</style>
